var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"how2use"}},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":function($event){_vm.$refs.how2use.open()}}},[_vm._v("使い方")]),_c('md-dialog-alert',{ref:"how2use",attrs:{"md-content":"欲しい報酬にチェックを付けて現在状況を入力するだけ！","md-ok-text":"膣"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ab9d8a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HowToUse.vue
// module id = Cwmf
// module chunks = 1